import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

interface TrendsContextProps {
  occupationTitle: string;
  locationName: string;
}

/**
 * Historical wage trends explanation for trends pages
 */
export default function TrendsContext({ 
  occupationTitle, 
  locationName 
}: TrendsContextProps) {
  return (
    <Card className="mb-6">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <TrendingUp className="h-5 w-5" />
          Historical Wage Trends
        </CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-muted-foreground leading-relaxed mb-4">
          Understanding historical wage trends for {occupationTitle} in {locationName} provides valuable insights 
          into salary growth patterns, economic cycles, and career planning. The data below shows how wages have 
          changed over time, adjusted for inflation and regional economic conditions.
        </p>
        <p className="text-muted-foreground leading-relaxed">
          <strong>What This Means for Your Career:</strong> Analyzing wage trends helps you understand whether 
          salaries are growing, stable, or declining in your field. This information is crucial for salary negotiations, 
          career transitions, and long-term financial planning. Factors such as industry growth, technological changes, 
          and regional economic conditions all influence wage trends over time.
        </p>
      </CardContent>
    </Card>
  );
}

